import AppComponent, {MAP_VIEW} from '../components/App';
import React from 'react';
import { connect } from 'react-redux';

const Container = ({padding}) => (
    <div>
        <AppComponent view={MAP_VIEW} padding={padding} /> 
    </div>
);


const mapDispatchToPropsRes = (dispatch) => {

  return {
  }
}

const mapStateToPropsRes = (state) => {

	
	return {
		padding: state.map.padding
	}
}

const AppContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Container);

export default AppContainer;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/app/container.js